export default "__VITE_ASSET__B9yN8TDC__"